import React from "react";
import { Link } from "react-router-dom";
import "../styles/Industries.css";
import { useLanguage } from "../contexts/LanguageContext";
import { track } from "../utils/analytics";

const Industries = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";
  const ind = text.industries;

  return (
    <section id="industries" className="industries-section" dir={isHeb ? "rtl" : "ltr"}>
      <span className="eyebrow">{ind.eyebrow}</span>
      <h2 className="section-title">{ind.title}</h2>
      <p className="industries-lede">{ind.lede}</p>

      <div className="industries-grid">
        {ind.items.map((item) => (
          <Link
            key={item.key}
            to={`/${item.slug}`}
            className="industry-card"
            onClick={() => track("industry_click", { slug: item.slug })}
          >
            <div className="industry-icon" aria-hidden="true">
              {item.icon}
            </div>
            <h3 className="industry-name">{item.name}</h3>
            <p className="industry-tagline">{item.tagline}</p>
            <div className="industry-outcome">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                <path d="M5 12l5 5L20 7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>{item.outcome}</span>
            </div>
            <span className="industry-cta">
              {ind.cta}
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.2">
                <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Industries;
